import { memo } from "react"

const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_10062_45093)">
        <path
          d="M19.6667 20.8061C19.6667 21.3918 19.1918 21.8667 18.6061 21.8667H7.01767C6.98733 21.8667 6.95583 21.8783 6.9255 21.8783C6.887 21.8783 6.8485 21.8678 6.80883 21.8667H4.39394C3.80818 21.8667 3.33333 21.3918 3.33333 20.8061V6.59395C3.33333 6.00819 3.80818 5.53335 4.39394 5.53335H10.8822C11.1635 5.53335 11.4332 5.4216 11.6321 5.2227L11.8443 5.01058C12.5124 4.34243 12.0392 3.20001 11.0943 3.20001H3.33333C2.0465 3.20001 1 4.24535 1 5.53335V21.8667C1 23.1547 2.0465 24.2 3.33333 24.2H19.6667C20.2855 24.2 20.879 23.9542 21.3166 23.5166C21.7542 23.079 22 22.4855 22 21.8667V14.3145C22 13.3696 20.8576 12.8964 20.1894 13.5646L19.9773 13.7767C19.7784 13.9756 19.6667 14.2454 19.6667 14.5267V20.8061Z"
          fill="#002C98"
        />
        <path
          d="M8.50795 11.9448L7.52461 16.1977C7.49069 16.3532 7.49185 16.5143 7.52801 16.6693C7.56417 16.8242 7.63442 16.9691 7.73363 17.0934C7.83283 17.2177 7.95848 17.3182 8.1014 17.3875C8.24432 17.4569 8.40091 17.4934 8.55971 17.4944C8.6337 17.5019 8.70826 17.5019 8.78225 17.4944L13.052 16.5089L21.25 8.32455L16.6749 3.75L8.50795 11.9448Z"
          fill="#002C98"
        />
        <path
          d="M23.6687 4.51662L20.478 1.32588C20.2682 1.11717 19.9843 1 19.6884 1C19.3925 1 19.1086 1.11717 18.8988 1.32588L17.125 3.09971L21.9003 7.875L23.6741 6.10117C23.7779 5.99684 23.8601 5.87306 23.9161 5.73692C23.972 5.60078 24.0005 5.45495 24 5.30777C23.9995 5.16059 23.97 5.01496 23.9131 4.87921C23.8563 4.74345 23.7732 4.62024 23.6687 4.51662Z"
          fill="#002C98"
        />
      </g>
      <defs>
        <clipPath id="clip0_10062_45093">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(EditIcon)
